import type { ReactNode } from 'react';
export function LoadingNote() { return <p className="py-13 text-body-sm text-text-muted">Loading…</p>; }
export function ErrorNote({ children }: { children: ReactNode }) { return <p className="py-13 text-body-sm text-flagged">{children}</p>; }
export function EmptyNote({ children }: { children: ReactNode }) { return <p className="py-13 text-body-sm text-text-muted">{children}</p>; }
